module.exports = __webpack_public_path__ + "static/invitor_btn.32b59621.png";